export class ReviewUpdatedEvent {
  constructor(public readonly reviewId: number) {}
}
